const ActiveMarker = () => (
  <svg
    className="absolute top-1/2 -right-0.25 md:-right-9 custom-translate-y-50 w-[20px] h-[37px]"
    width="41"
    height="74"
    viewBox="0 0 41 74"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.567609 38.396C-0.0299384 37.8348 -0.0299384 36.8857 0.567609 36.3244L37.9721 1.19151C38.8793 0.339364 40.366 0.982621 40.366 2.2273L40.366 72.4932C40.366 73.7379 38.8793 74.3811 37.9721 73.529L0.567609 38.396Z"
      fill="white"
    />
  </svg>
);

export default ActiveMarker;
